const en = {

    // Navigation
    home: 'Home',
    marketplace: 'Marketplace',
    products: 'Products',
    login: 'Login',
    logout: 'Logout',
    register: 'Register',
    myAccount: 'My Account',
    adminPanel: 'Admin Panel',
    cart: 'Cart',
    
    // Hero Section
    heroTitle: 'Game top-ups & gift cards worldwide',
    heroSubtitle: 'Instant delivery · Card & crypto globally · NatCash & MonCash in Haiti',
    heroSubtitleGlobal: 'Instant delivery · Pay with card (USD) or crypto worldwide',
    globalHeroBadge: 'Trusted digital store · 50+ countries',
    globalPaymentsRibbon: '🌍 Card & crypto worldwide · 🇭🇹 NatCash & MonCash in Haiti',
    globalPaymentsRibbonGlobal: '🌍 Card & crypto worldwide · Secure checkout',
    trendingGamesTitle: 'Trending worldwide',
    howItWorksLink: 'How it works',
    heroSlide2Title: 'Instant Digital Delivery',
    heroSlide2Subtitle: 'Get your codes delivered instantly after payment',
    heroSlide3Title: 'Best Prices Guaranteed',
    heroSlide3Subtitle: 'The most competitive prices for all digital products',
    exploreProducts: 'Explore Products',
    shopNow: 'Shop Now',
    downloadApp: 'Download App',
    installApp: 'Install App',
    installAppHint: 'To install: open the Chrome menu (⋮), then tap “Install app” or “Add to Home screen”.',
    appInstalledToast: 'KayiCom is installed. Open it from your home screen!',
    apkDownloadStarted: 'Downloading the APK. Open the file and tap Install.',
    appUpdateTitle: 'Update available',
    appUpdateMessage: 'A new KayiCom version is ready. Update now for the latest fixes and features.',
    appUpdateLater: 'Later',
    appUpdateNow: 'Update now',
    appUpdateInstalling: 'Downloading update…',
    appUpdatePermission: 'Allow KayiCom to install updates, then try again.',
    appUpdateFailed: 'Update failed. Please try again.',
    appUpdateManualHint: 'Open this page in Chrome, tap Download, then install the new KayiCom APK once. Future updates will install from the app.',
    appUpdateVersionLine: 'You have v{local} → v{remote}',
    appUpdatePlayProtectHint: 'If Play Protect blocks install, choose Install anyway.',
    getStarted: 'Get Started',
    
    // Features
    instantDelivery: 'Instant Delivery',
    instantDeliveryDesc: 'Codes delivered in seconds',
    securePayment: 'Secure Payment',
    securePaymentDesc: 'Protected transactions',
    support247: '24/7 Support',
    support247Desc: 'Help whenever you need it',
    competitivePrice: 'Competitive Prices',
    competitivePriceDesc: 'Best value guaranteed',
    
    // Homepage
    bestsellerLabel: 'Bestsellers',
    bestSellingProducts: 'Best Selling Products',
    categoryDeals: 'Hot Deals',
    viewAll: 'View All',
    latestBlogPosts: 'Latest Blog Posts',
    visitBlog: 'Visit Blog',
    salesCount: 'sold',
    noProductsAvailable: 'No products available',
    totalProducts: 'Products',
    totalSales: 'Sales',
    totalCategories: 'Categories',

    // Blog
    blog: 'Blog',
    blogSubtitle: 'Guides, announcements, and tips for digital products and streaming',
    blogFeatured: 'Featured',
    readMore: 'Read more',
    readArticle: 'Read article',
    backToBlog: 'Back to blog',
    loadingPosts: 'Loading posts...',
    loadingPost: 'Loading article...',
    noBlogPosts: 'No blog posts published yet.',
    postNotFound: 'This article is not available.',
    minRead: 'min read',
    relatedArticles: 'Related Articles',
    allArticles: 'All Articles',

    // Products
    allProducts: 'All Products',
    productsSubtitle: 'Find the best digital deals instantly.',
    noProductsInCategory: 'No products available in this category',
    noProductsYet: 'No products yet.',
    showingResultsFor: 'Showing results for',
    itemsCount: 'items',
    allCategories: 'All',

    // Top-Up
    topupHeroTitle: 'Game Top-Up',
    topupHeroSubtitle: 'Recharge Free Fire LATAM and Delta Force — delivered instantly to your account.',
    topupPlayerVerify: 'Player ID Verification',
    topupPlayerVerifyDesc: 'We verify your ID before delivery',
    topupAutoDelivery: 'Automatic Delivery',
    topupAutoDeliveryDesc: 'Credits delivered in minutes',
    browseByGame: 'Browse by Game',
    allGames: 'All Games',
    otherGames: 'Other Games',
    howItWorks: 'How It Works',
    topupStep1: 'Choose your game & package',
    topupStep2: 'Select a package and enter your Player ID',
    topupStep3: 'Pay securely & receive instantly',
    topupIdDialogDesc: 'Enter your in-game ID to continue. This is required for delivery.',
    topupSelectPackage: 'Select a package',
    topupPackages: 'packages',
    topupBuy: 'Buy now',
    topupOfficialBadge: 'Official top-up',
    topupProductSubtitle: 'Choose a pack and top up your account!',
    topupVerifyPlayerId: 'Verify player ID',
    topupSelected: 'Selected package',
    topupSearchGames: 'Search games...',
    topupPopularGames: 'Popular',
    topupSelectGame: 'Choose your game',
    topupInstantBadge: 'Instant',
    topupPopularSection: 'Popular',
    topupDirectSection: 'Direct Top-Up',
    topupBestSellers: 'Best sellers for you',
    topupBestSellerBadge: 'Best seller',
    topupBrowseAll: 'Browse all packages',
    topupStepEnterId: 'Enter Player ID',
    topupSelectTopUp: 'Select Top-Up',
    topupContinueCheckout: 'Continue to checkout',
    topupViewAll: 'View all',
    topupTrending: 'Trending',
    topupPacksDiamonds: 'Diamonds',
    topupPacksCoins: 'Pièces',
    topupPacksUc: 'UC',
    topupPacksRobux: 'Robux',
    topupPacksCp: 'CP',
    topupPacksGold: 'Gold',
    topupPacksSpecials: 'Special offers',
    topupPacksBonus: 'Bonus',
    accountType: 'Account type',
    backToGames: 'Back to games',
    playerName: 'Player name',
    fromPrice: 'From',
    noTopupPackages: 'No packages found for this game yet.',
    viewGamePage: 'Open game page',

    // Subscriptions
    subscriptionHeroTitle: 'Premium Subscriptions',
    subscriptionHeroSubtitle: 'Netflix, Spotify, Disney+, YouTube Premium and more — activated fast at unbeatable prices.',
    subscriptionInstantDesc: 'Access details delivered within minutes',
    subscriptionRenewLabel: 'Flexible Plans',
    subscriptionRenewDesc: 'Choose the duration that fits you',
    subscriptionStep1: 'Pick your subscription and plan duration',
    subscriptionStep2: 'Pay securely with your preferred method',
    subscriptionStep3: 'Receive your access details and enjoy',
    editPlayerId: 'Change Player ID',
    saveAndContinue: 'Save & Continue',
    playerIdRequired: 'Player ID is required',
    idSaved: 'ID saved',
    verifyingId: 'Verifying...',
    idVerified: 'ID verified',
    floatingAnnouncementLabel: 'Notice',
    floatingAnnouncementDismiss: 'Got it',

    // NatCash payment
    natcashPaymentTitle: 'NatCash Payment',
    natcashAccountName: 'Account Name',
    natcashPhone: 'NatCash Number',
    natcashAmount: 'Amount to Send',
    natcashReference: 'Reference Code (put in Content)',
    natcashWaitingPayment: 'Waiting for payment',
    natcashHowToPay: 'How to pay with NatCash:',
    natcashStep1: 'Dial *202# on your phone',
    natcashStep2: 'Choose Transfer',
    natcashStep3: 'Enter the exact amount shown above',
    natcashStep4: 'In the Content field, enter the reference code shown above',
    natcashStep5: 'Enter your NatCash PIN',
    natcashStep6: 'Press Send to complete payment',
    natcashPhoneWarning: 'The phone number you send from must match the one you used when placing the order.',
    natcashVerifyNow: 'VERIFY NOW',
    natcashSmsCountdown: 'Waiting for SMS',
    natcashAutoCheck: 'The system checks automatically every 10 seconds',
    natcashAutoPayHint: 'Send the exact amount and put the reference code in Kontni — confirmed automatically.',
    natcashVerifying: 'Verifying...',
    natcashCopy: 'COPY',
    natcashCopied: 'Copied!',
    natcashAutoPayment: 'Automatic payment — NatCash/Natcom',
    natcashTotalHtg: 'NatCash Total (HTG)',
    paymentConfirmed: 'Payment confirmed!',
    paymentConfirming: 'Confirming your payment…',
    paymentConfirmedDesc: 'Your payment has been confirmed successfully.',
    paymentSuccessDeliveryHint: 'Automatic orders are delivered within a few seconds. Open the order to view your delivery.',
    paymentConfirmedPreparingDelivery: 'Payment confirmed. We are preparing your delivery. Open this page again to view it.',
    autoDeliveryPendingHint: 'Your order has been received and is being processed. Please be patient while we complete your delivery.',

    // Transcode (NatCash / MonCash SMS)
    transcodeLabel: 'Transcode',
    transcodePayHint: 'Pay the exact amount above, then paste the Transcode from your payment SMS below.',
    moncashPayHint: 'Pay the exact amount with your MonCash number (509 + 8 digits) — confirmation is automatic from your number and the amount, no Transcode needed.',
    moncashOrderCreated: 'Order created! Pay the exact amount with your MonCash number — confirmation is automatic from your number and the amount.',
    moncashTopupCreated: 'Topup created! Pay the exact amount with your MonCash number — confirmation is automatic from your number and the amount.',
    transcodeSmsNote: 'After you pay, NatCash sends a confirmation SMS to your phone. The Transcode is in that message — copy it and paste it in the field below.',
    transcodePlaceholder: 'e.g. 26082105770513',
    transcodeEnterHint: 'Enter the Transcode from your NatCash SMS',
    transcodeVerify: 'Verify amount + Transcode',
    transcodeVerifying: 'Verifying amount + Transcode…',
    transcodeApproved: 'Payment confirmed.',

    // MonCash payment
    moncashAutoPayment: 'Automatic MonCash payment (HTG)',
    moncashMinPurchase: 'Minimum purchase',
    moncashNeedMore: 'you need',
    moncashNeedMoreSuffix: 'more',
    moncashFee: 'MonCash fee',
    natcashFee: 'NatCash fee',
    htgPaymentFee: 'Payment fee',
    moncashFeeOnOrder: 'on this order',
    moncashMinimum: 'Minimum MonCash',
    moncashTotalWithFee: 'Total with fee',
    moncashAmountToPay: 'Amount to pay on MonCash',
    moncashMerchantPhone: 'MonCash number',
    moncashPayerPhone: 'Number you must send from',
    moncashToPay: 'Amount to pay',
    moncashPayWith: 'Pay with MonCash',
    moncashAutoConfirm: 'Automatic confirmation after MonCash payment',
    moncashOpenPayment: 'Open MonCash Payment',
    moncashIPaidVerify: 'I paid — Verify',
    moncashChecking: 'Checking…',
    moncashLinkMissing: 'MonCash payment link missing',
    moncashVerifyFailed: 'Could not verify MonCash payment',
    moncashPaymentConfirmed: 'MonCash payment confirmed!',
    moncashPaymentPending: 'Payment still pending',
    moncashRedirecting: 'Redirecting to MonCash...',
    moncashContinueOnTracking: 'Order created! Continue MonCash payment on tracking page.',
    moncashMinPurchaseIs: 'MonCash minimum purchase is',
    moncashMinShort: 'MonCash min',
    moncashOrderTotal: 'Order total',
    plopplopUssdOption: 'Pay by USSD prompt on your MonCash phone — no redirect page',
    plopplopUssdHint: 'The API sends the USSD prompt and returns the TRANSACTION id. Approve it on your phone; we confirm that API id automatically.',
    plopplopUssdNoPromptHint: 'No USSD prompt is sent if that MonCash e-money balance is too low, or if the number is NatCash.',
    plopplopUssdResend: 'Resend USSD prompt',
    plopplopUssdResent: 'A new MonCash USSD prompt was requested. Approve it on the same phone.',
    plopplopUssdResendFailed: 'Could not resend the USSD prompt',
    ussdPayPageTitle: 'MonCash USSD payment',
    ussdPayPageHint: 'The API sends the USSD prompt and returns the TRANSACTION id. Approve it on your phone; we confirm that API id automatically.',
    ussdPayButton: 'Pay',
    ussdIPaidButton: 'I paid',
    ussdTxnFromSms: 'MonCash transaction number from the SMS',
    ussdTxnFromSmsHint: 'If I paid cannot find it, enter the transaction number from the MonCash SMS, then tap I paid again.',
    ussdPaySent: 'USSD prompt sent. Approve it on your MonCash phone.',
    ussdPayWaiting: 'Checking the API TRANSACTION id… you do not enter any number.',
    plopplopPhoneLabel: 'MonCash phone number',
    plopplopPhoneRequired: 'Enter a valid MonCash number (39308318)',
    plopplopRedirectHint: 'Complete payment on the secure page. This screen updates automatically, then your order is delivered.',
    plopplopCardTitle: 'Debit / Credit Card',
    plopplopCardDesc: 'Pay securely by card (USD). Your details are sent automatically.',
    plopplopCardHint: 'Complete the card payment. The amount is charged in USD. This screen updates automatically, then your order is delivered.',
    plopplopCardRedirecting: 'Redirecting to card payment (USD)…',
    plopplopOpenCardPayment: 'Continue card payment',
    plopplopOpenHostedPayment: 'Continue payment',
    plopplopPaymentExpired: 'This payment expired after 10 minutes. Place a new order to pay.',
    plopplopCardAmountHtg: 'Card total (USD)',
    plopplopCardFee: 'Card fee',
    plopplopCardPayUsd: 'Charged in USD',
    plopplopCardAutoConfirm: 'Payment is confirmed automatically after you pay.',
    redirectingCardPayment: 'Redirecting to card payment…',
    stripeCardPayTitle: 'Secure card payment',
    stripeCardWalletHint: 'Google Pay and Apple Pay appear on the secure checkout page when your device supports them.',
    stripeCardPaySubtitle: 'Enter your card details to complete your order.',
    stripeCardEmbeddedHint: 'Pay securely with debit or credit card (USD).',
    continueToCard: 'Continue to card payment',
    payWithCard: 'Pay with card',
    backToOrder: 'Back to order',
    stripeAcceptedCards: 'We accept',
    stripe3dsHint: '3D Secure verification when required',
    stripeStatementPrefix: 'Card statement',
    poweredBy: 'Powered by',
    cardNumber: 'Card number',
    cardExpiry: 'Expiry date',
    cardCvc: 'CVV',
    saveCardForNextPayment: 'Save this card for my next payment',
    stripeCardFormHint: 'Enter your card number, expiry date, and CVV.',
    stripeSecuredBy: 'Secured by Stripe',
    stripeHostedPayHint: 'Enter your card number, expiry date, and CVV below.',
    stripeWalletHint: 'Pay with Apple Pay, Google Pay, or card',
    stripeApplePayTitle: 'Apple Pay',
    stripeGooglePayTitle: 'Google Pay',
    stripeApplePayHint: 'Use Apple Pay to complete your order securely.',
    stripeGooglePayHint: 'Use Google Pay to complete your order securely.',
    stripeApplePayCheckoutHint: 'Pay with Apple Pay on your device.',
    stripeGooglePayCheckoutHint: 'Pay with Google Pay on your device.',
    stripeApplePayUnavailable: 'Apple Pay is not available right now. Make sure you have a card in Wallet, open the site in Safari, and try again. Otherwise use debit/credit card.',
    stripeGooglePayUnavailable: 'Google Pay is not available on this device or browser. Try Chrome on Android, or use debit/credit card.',
    redirectingApplePay: 'Redirecting to Apple Pay…',
    redirectingGooglePay: 'Redirecting to Google Pay…',
    continueToApplePay: 'Continue to Apple Pay',
    continueToGooglePay: 'Continue to Google Pay',
    stripeGooglePayUnavailableIos: 'Google Pay does not work in the browser on iPhone. Use Apple Pay or debit/credit card instead.',
    stripeApplePayUnavailableAndroid: 'Apple Pay is not available on Android. Use Google Pay or debit/credit card instead.',
    stripeApplePayUnavailableSafari: 'On iPhone, open kayicom.com in Safari (not Chrome) to use Apple Pay.',
    stripeWalletUnavailable: 'This wallet is not available on this device or browser.',
    stripeWalletChooseAnotherMethod: 'Choose another payment method',
    stripeWalletLoadError: 'Could not load the wallet payment button. Try again or choose another payment method.',
    retry: 'Retry',
    stripeGooglePayHostedFallback: 'Open Google Pay checkout',
    stripeApplePayHostedFallback: 'Open Apple Pay checkout',
    stripeGooglePayChromeHint: 'On Android, use Chrome with Google Pay set up in your Google account.',
    stripeApplePaySafariHint: 'On iPhone, use Safari with Apple Pay enabled in Settings.',
    stripeWalletHostedFallbackLink: 'Button not showing? Open secure wallet checkout',
    stripeGooglePayHostedHint: 'Tap below to pay with Google Pay on the secure Stripe page.',
    stripeApplePayHostedHint: 'Tap below to pay with Apple Pay on the secure Stripe page.',
    payWithGooglePay: 'Pay with Google Pay',
    payWithApplePay: 'Pay with Apple Pay',
    paymentDescription: 'Payment description',
    playerFound: 'Player found',
    
    // Categories
    categoryTitle: 'Product Categories',
    giftCards: 'Gift Cards',
    gameTopup: 'Game Top-Up',
    subscriptions: 'Subscriptions',
    services: 'Services',
    crypto: 'Crypto',
    
    // What We Offer
    whatWeOffer: 'What We Offer',
    offerSubtitle: 'Choose from multiple categories of digital products with immediate delivery',
    internationalGiftCards: 'International Gift Cards',
    giftCardsDesc: 'Amazon, Google Play, iTunes, Steam and more',
    automaticGameTopup: 'Automatic Game Top-Up',
    gameTopupDesc: 'Free Fire LATAM and Delta Force - instant delivery',
    premiumSubscriptions: 'Premium Subscriptions',
    subscriptionsDesc: 'Netflix, Spotify, Disney+ and other services',
    digitalServices: 'Digital Services',
    servicesDesc: 'Create Stripe account, verify PayPal, TextNow',
    
    // Featured Products
    featuredProducts: 'Featured Products',
    buyNow: 'Buy Now',
    addToCart: 'Add to Cart',
    viewDetails: 'View Details',
    available: 'Available',
    outOfStock: 'Out of Stock',
    
    // Ready to Start
    readyToStart: 'Ready to Start?',
    
    // Auth
    email: 'Email',
    emailPlaceholder: 'your@email.com',
    whatsappNumber: 'WhatsApp number',
    whatsappPlaceholder: '50912345678',
    password: 'Password',
    fullName: 'Full Name',
    confirmPassword: 'Confirm Password',
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: 'Already have an account?',
    createAccount: 'Create Account',
    gmailYahooOnly: 'Use a Gmail or Yahoo email address to create an account.',
    verifyEmailSent: 'Account created. Check your email and verify it to continue.',
    verifyEmailToContinue: 'Verify your email to continue. We sent you a link.',
    verifyEmailTitle: 'Verify your email',
    verifyEmailMissingToken: 'Open the verification link from your email, or resend it.',
    verifyEmailBanner: 'Verify your email to place your first order.',
    resendVerification: 'Resend verification email',
    rememberMe: 'Remember me',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    forgotPassword: 'Forgot password?',
    orContinueWith: 'or continue with',
    continueWithGoogle: 'Continue with Google',
    continueWithTelegram: 'Continue with Telegram',
    socialLoginStateInvalid: 'Social login session expired. Please try again.',
    securityCheck: 'Security check',
    securityCheckHint: 'Solve this simple math to prove you are human.',
    enterResult: 'Enter the result',
    solveSecurityCheck: 'Please solve the security check',
    refresh: 'Refresh',
    resetPassword: 'Reset password',
    sendResetLink: 'Send reset link',
    backToLogin: 'Back to login',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    passwordsDoNotMatch: 'Passwords do not match',
    resetLinkSent: 'If the email exists, a reset link has been sent.',
    resetSuccess: 'Password reset successful. Please log in.',
    tokenMissing: 'Reset token is missing or invalid.',
    
    // Cart & Checkout
    yourCart: 'Your Cart',
    emptyCart: 'Your cart is empty',
    continueShopping: 'Continue Shopping',
    orderSummary: 'Order Summary',
    subtotal: 'Subtotal',
    total: 'Total',
    items: 'items',
    checkout: 'Checkout',
    placeOrder: 'Place Order',
    
    // Payment
    paymentMethod: 'Payment Method',
    cryptocurrency: 'Cryptocurrency (Automatic)',
    manualPayment: 'Manual Payment',
    cryptoDesc: 'Bitcoin, Ethereum, and more',
    manualDesc: 'Bank transfer, other methods (proof required)',
    
    // Order Tracking
    orderTracking: 'Order Tracking',
    orderNumber: 'Order',
    orderStatus: 'Order Status',
    paymentStatus: 'Payment Status',
    orderItems: 'Order Items',
    submitProof: 'Submit Payment Proof',
    transactionId: 'Transaction ID',
    proofUrl: 'Proof URL',
    uploadProof: 'Upload Proof',
    
    // Dashboard
    dashboard: 'Dashboard',
    myOrders: 'My Orders',
    totalOrders: 'Total Orders',
    pendingOrders: 'Pending Orders',
    completedOrders: 'Completed Orders',
    noOrders: 'You don\'t have any orders yet',
    
    // Admin
    manageProducts: 'Manage Products',
    manageOrders: 'Manage Orders',
    siteSettings: 'Site Settings',
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    deleteProduct: 'Delete Product',
    productName: 'Product Name',
    description: 'Description',
    category: 'Category',
    price: 'Price',
    currency: 'Currency',
    imageUrl: 'Image URL',
    stockAvailable: 'Stock Available',
    deliveryType: 'Delivery Type',
    automatic: 'Automatic',
    manual: 'Manual',
    save: 'Save',
    cancel: 'Cancel',
    
    // Settings
    general: 'General',
    apiKeys: 'API Keys',
    appearance: 'Appearance',
    siteName: 'Site Name',
    supportEmail: 'Support Email',
    logoUrl: 'Logo URL',
    primaryColor: 'Primary Color',
    secondaryColor: 'Secondary Color',
    saveSettings: 'Save Settings',
    
    // Footer
    aboutUs: 'About Us',
    contact: 'Contact',
    footerCompany: 'Company',
    footerCategories: 'Categories',
    footerSocial: 'Social',
    footerBlogs: 'Blog',
    footerTagline:
      'Gift cards, game top-ups, subscriptions, and digital services with fast delivery.',
    footerSocialComingSoon: 'Follow us soon on social media.',
    quickLinks: 'Quick Links',
    support: 'Support',
    refundPolicy: 'Refund Policy',
    privacyPolicy: 'Privacy Policy',
    amlPolicy: 'AML Policy',
    legalPagesNav: 'Legal & policies',
    legalOnThisPage: 'On this page',
    allRightsReserved: 'All rights reserved',
    trustpilotViewReviews: 'View our Trustpilot reviews',
    
    // Messages
    loading: 'Loading...',
    processing: 'Processing...',
    success: 'Success!',
    error: 'Error',
    loginSuccess: 'Login successful!',
    logoutSuccess: 'Logout successful!',
    productAdded: 'Product added to cart',
    productRemoved: 'Product removed from cart',
    orderPlaced: 'Order placed successfully!',
    proofSubmitted: 'Payment proof submitted successfully!',

    // Wallet
    myWallet: 'My Wallet',
    withdrawBalance: 'Withdraw Balance',
    pendingBalance: 'Pending Balance',
    consumableBalance: 'Consumable Balance',
    withdraw: 'Withdraw',
    recharge: 'Recharge',
    topUpWallet: 'Top Up Wallet',
    amountUsd: 'Amount (USD)',
    enterAmount: 'Enter amount',
    toPayHtg: 'To pay: {amount} HTG',
    confirm: 'Confirm',
    creditsBalance: 'Credits Balance',
    creditsRateHint: '1000 credits = $1.00',
    creditsPlaceholder: 'Credits',
    convert: 'Convert',
    transactionsTab: 'Transactions',
    topupsTab: 'Topups',
    noTransactionsYet: 'No transactions yet',
    noTopupsYet: 'No topups yet',
    topupDetails: 'Topup Details',
    close: 'Close',
    selectTopupDetails: 'Select a topup to see details.',
    walletCredited: 'Wallet credited successfully.',
    paidCrediting: 'Paid — crediting wallet...',
    openPlisioInvoice: 'Open Plisio Invoice',
    cryptoInvoiceAuto: 'Your crypto invoice should open automatically.',
    iPaidVerifyCrypto: 'I paid — Verify crypto',
    cryptoAutoCheck: 'We also auto-check every 10 seconds after you pay.',
    verifying: 'Verifying...',
    errorLoadingWallet: 'Error loading wallet',
    enterValidAmount: 'Enter a valid amount',
    enterCreditsMultiple: 'Enter credits to convert (multiple of 1000)',
    creditsMustBeMultiple: 'Credits must be a multiple of 1000',
    convertedCreditsSuccess: 'Converted {credits} credits → {amount}',
    errorConvertingCredits: 'Error converting credits',
    redirectingCryptoPayment: 'Redirecting to crypto payment...',
    cryptoNotAvailable: 'Crypto payment not available — Plisio API key not configured',
    topupCreatedTranscode: 'Topup created — pay and enter your Transcode below.',
    topupCreatedAuto: 'Topup created — payment will be verified automatically',
    errorCreatingTopup: 'Error creating topup',
    paymentConfirmedWallet: 'Payment confirmed! Wallet credited.',
    cryptoNotConfirmedYet: 'Crypto payment not confirmed yet',
    plisioVerifyFailed: 'Plisio verification failed',
    cryptoAuto: 'Crypto (Automatic)',
    natcashAuto: 'NatCash (Auto)',
    moncashAuto: 'MonCash (Auto)',
    binancePayAuto: 'Binance Pay (Auto)',

    // Dashboard extended
    balance: 'Balance',
    points: 'Points',
    sellerCenter: 'Seller Center',
    sellerApplication: 'Seller Application',
    becomeSeller: 'Become a Seller',
    purchasedOrders: 'Purchased Orders',
    mySubscriptions: 'My Subscriptions',
    coupon: 'Coupon',
    referral: 'Referral',
    messages: 'Messages',
    disputes: 'Disputes',
    helpCenter: 'Help Center',
    notification: 'Notification',
    termsConditions: 'Terms & Conditions',
    termsContactHeading: 'Contact',
    termsContactText: 'Questions about these terms? Email us at',
    customerIdCopied: 'Customer ID copied',
    couldNotCopy: 'Could not copy',
    customer: 'Customer',
    pendingBadge: 'Pending',
    activeBadge: 'active',
    newBadge: 'new',
    filterAll: 'All',
    filterPending: 'Pending',
    filterProcessing: 'Processing',
    filterCompleted: 'Completed',
    filterCancelled: 'Cancelled',
    orderHash: 'Order #{id}',
    itemsLabel: 'items',
    startShopping: 'Start Shopping',
    noOrdersYet: 'No orders yet',
    oneYear: '1 Year',
    month: 'Month',
    months: 'Months',
    paymentMethodCryptocurrency: 'Cryptocurrency',
    paymentMethodBinancePay: 'Binance Pay (Auto)',
    paymentMethodBinanceManual: 'Binance Pay (Manual)',

    // Checkout extended
    mustLoginToContinue: 'You must login to continue',
    walletBalanceTitle: 'Wallet Balance',
    clickLoadWalletBalance: 'Click to load wallet balance',
    balanceAmount: 'Balance: {amount}',
    insufficientWalletBalance: 'Insufficient balance. Top up your wallet first.',
    topUpWalletBtn: 'Top up wallet',
    cryptoCheckoutDesc: 'Bitcoin, Ethereum, USDT - Instant delivery',
    binancePay: 'Binance Pay',
    autoVerified: 'Auto-verified',
    cashApp: 'Cash App',
    cashAppManualDesc: 'Manual verification — submit payment proof after paying',
    sendTo: 'Send to:',
    playerIdsRequired: 'Player IDs Required',
    playerIdFor: '{label} for {product}',
    enterYourLabel: 'Enter your {label}',
    playerIdsSaved: 'Player IDs',
    accountCredentialsRequired: 'Account Credentials Required',
    enterField: 'Enter {field}',
    couponCode: 'Coupon Code',
    enterCoupon: 'Enter coupon',
    apply: 'Apply',
    applying: 'Applying...',
    clear: 'Clear',
    couponApplied: 'Coupon applied',
    couponActive: 'Coupon active for this order.',
    minOrderForCoupon: 'Minimum order for this coupon: {amount}',
    discount: 'Discount',
    secureTransaction: 'Secure transaction',
    fastDelivery: 'Fast delivery',
    mustLoginBeforePurchase: 'You must login before purchasing',
    cartEmpty: 'Your cart is empty',
    enterPlayerIdFirst: 'Enter a Player ID first',
    playerIdVerified: 'Player ID verified!',
    invalidPlayerId: 'Invalid Player ID',
    verificationFailed: 'Verification failed. Please try again.',
    redirectingPayment: 'Redirecting to payment...',
    orderCreatedTranscode: 'Order created! Pay with MonCash and enter your Transcode on the order page.',
    orderCreatedNatcash: 'Order created! Send the exact HTG amount and put your reference code in Kontni — we confirm automatically.',
    paidWithWallet: 'Paid with wallet successfully!',
    orderCreatedSubmitProof: 'Order created! Please submit your payment proof.',
    errorCreatingOrder: 'Error creating order',
    sessionExpiredLogin: 'Your session expired. Please log in again and retry payment.',
    enterCouponCode: 'Enter a coupon code',
    invalidCoupon: 'Invalid coupon',
    autoLabel: 'Auto',
    checkoutPaymentsRegionHaiti: 'Recommended for Haiti: NatCash or MonCash (HTG).',
    checkoutPaymentsRegionGlobal: 'Pay worldwide with debit/credit card (USD) or crypto.',
    growthShareTitle: 'Share & earn',
    growthShareSubtitle: 'Invite friends to KayiCom',
    growthShareEarn: 'Earn $1 when a friend completes their first subscription through your link.',
    growthShareGuestTitle: 'Create an account to get your referral link',
    growthShareGuestSubtitle: 'Share KayiCom with friends and earn rewards.',
    growthYourLink: 'Your referral link',
    growthCopyLink: 'Copy link',
    growthCopyLinkDone: 'Link copied!',
    growthCopyLinkFail: 'Could not copy link',
    growthShareWhatsApp: 'WhatsApp',
    growthShareTelegram: 'Telegram',
    growthShareWhatsAppText: 'Shop game top-ups & gift cards on KayiCom — fast, secure delivery.',
    growthGoReferral: 'Referral dashboard →',
    growthSharePageLabel: 'Share this page with friends',
    growthSharePageText: 'Check out {title} on KayiCom — fast & secure delivery.',
    growthShareNative: 'Share',
    growthViralSectionTitle: 'Invite friends, earn rewards',
    referralPageTitle: 'Referral program',
    referralPageSubtitle: 'Share KayiCom with friends. Earn $1 when someone you referred completes their first subscription.',
    referralPageBalance: 'Available balance',
    referralPageTotalReferrals: 'Friends joined',
    referralPagePerSub: 'Per subscription',
    referralPageCodeLabel: 'Your code:',
    referralPageHowTitle: 'How it works',
    referralPageStep1Title: 'Share your link',
    referralPageStep1Desc: 'Send your personal link on WhatsApp, Telegram, or social media.',
    referralPageStep2Title: 'They subscribe',
    referralPageStep2Desc: 'When your friend buys their first subscription plan on KayiCom, you earn $1.',
    referralPageStep3Title: 'Withdraw your earnings',
    referralPageStep3Desc: 'Cash out referral balance anytime once you reach the minimum.',
    referralPageMinWithdraw: 'Minimum withdrawal: $5.00 USD (card, crypto, PayPal, or MonCash).',
    referralPageWithdrawReady: 'You can withdraw your referral balance now.',
    referralPageWithdrawCta: 'Go to withdrawal',
    referralPageWithdrawNeedMore: 'Earn ${amount} more to reach the $5 minimum withdrawal.',
    referralPageLoadError: 'Could not load referral information.',
    referralPageRetry: 'Try again',
    howItWorksPageTitle: 'How KayiCom works',
    howItWorksPageSubtitle: 'Buy digital products in minutes — from anywhere in the world.',
    howItWorksStepPrefix: 'Step',
    howItWorksStep1Title: 'Choose your product',
    howItWorksStep1Desc: 'Pick a game top-up, gift card, or subscription from our catalog.',
    howItWorksStep2Title: 'Pay securely',
    howItWorksStep2Desc: 'Use card (USD), crypto, or — in Haiti — NatCash / MonCash.',
    howItWorksStep2DescGlobal: 'Pay with debit/credit card (USD), Binance Pay, or cryptocurrency.',
    howItWorksStep3Title: 'Instant delivery',
    howItWorksStep3Desc: 'Automatic products are delivered in minutes after payment is confirmed.',
    howItWorksStep4Title: 'Support if you need help',
    howItWorksStep4Desc: 'Our team is available 24/7 via WhatsApp and email.',
    howItWorksPaymentsTitle: 'Payment methods',
    howItWorksPaymentsGlobal: 'Worldwide: debit/credit card (USD), Binance Pay, and cryptocurrency.',
    howItWorksPaymentsHaiti: 'Haiti: NatCash (reference in Kontni, auto-confirm) and MonCash (Transcode from SMS).',
    howItWorksSupportWhatsApp: 'Chat with support on WhatsApp',
    gameLandingCta: 'Shop now',
    gameLandingHow: 'How it works',
    landingFreeFireTitle: 'Free Fire LATAM — instant top-up',
    landingFreeFireDesc: 'Recharge Free Fire LATAM diamonds safely with automatic delivery to your Player ID.',
    landingDeltaForceTitle: 'Delta Force — instant top-up',
    landingDeltaForceDesc: 'Top up Delta Force with automatic delivery to your Player ID.',
    landingPubgTitle: 'PUBG Mobile UC — fast top-up',
    landingPubgDesc: 'Buy PUBG Mobile UC online with secure payment and quick delivery.',
    landingMlbbTitle: 'Mobile Legends diamonds',
    landingMlbbDesc: 'Top up Mobile Legends diamonds in minutes — worldwide checkout.',
    landingRobloxTitle: 'Roblox Robux & gift cards',
    landingRobloxDesc: 'Get Roblox credit and gift cards with instant digital delivery.',
    landingNetflixTitle: 'Netflix & streaming',
    landingNetflixDesc: 'Streaming subscriptions and gift cards — ready to use after payment.',
    landingBulletInstant: 'Automatic delivery on eligible products',
    landingBulletSecure: 'Secure checkout — card, crypto, and local wallets',
    landingBulletSupport: '24/7 customer support',
};

export default en;
